import React, { useEffect } from "react";
import {
  cedulaNoVigente,
  MENSAJE_AYUDA_CEDULA_NO_VIGENTE,
  statusMessages,
} from "../statusMessages";
import {
  EnvioEmailSMSActivacionCuenta,
  renderBody,
  renderRedirectFlujoValidacionIdentidad,
  resolveNoSerieRestablecerConstraseñaAction,
} from "../actions";
import styles from "../../../../styles/stylesgenerales";
import { Button } from "devextreme-react";
import ReestablecimientoMessages from "./ReestablecimientoMessages";
import { paths } from "../../../../config/routes";
import { push } from "connected-react-router";
import { envioEmailSMSActivacionCuentaNoSerie } from "../../../../services/ValidacionIdentidad";
import { doResetState } from "../../Login/actions";
import StatusCuenta from '../EstatusCuenta/Index';

/**
 * @description Renderizar la pantalla intermedia con información acerca
 * del estatus de la cuenta de usuario y link al registro civil
 * para validar vigencia del documento
 * @param {*} statusCuenta Codigo de estatus de la cuenta de usuario
 * @param {*} message Mensaje de estatus de la cuenta de usuario
 * @param {*} dispatch Referencia a dispatch de redux
 * @author Tony Krikorian <tkrikoriam@achs.cl>
 */
const StatusCuentaUsuario = ({
  dispatch,
  statusCuenta,
  message,
  email,
  phone,
  emailMasked,
  phoneMasked,
}) => {
  const {
    ACTIVAR_CUENTA,
    VALIDACION_IDENTIDAD_INCORRECTA,
    REGISTRAR_USUARIO,
    RESTABLECER_CONTRASEÑA,
    CUENTA_BLOQUEADA,
    ERROR_SERVICIO,
  } = statusMessages;

  const { MENSAJE_VALIDACION_IDENTIDAD_INCORRECTA } = cedulaNoVigente;

  useEffect(() => {
    if(statusCuenta === ACTIVAR_CUENTA) {
      dispatch(
        EnvioEmailSMSActivacionCuenta(
          null,
          null,
          envioEmailSMSActivacionCuentaNoSerie,
          true
        )
      );
    }
  }, [statusCuenta])

  return (
    <center>
      <div className="acceso row">
        <div
          className="componentesLogin col-xs-12 col-sm-12 col-md-12 col-lg-12 text-center"
          style={{ margin: "2px 0" }}
        >
          <h2
            className="titulo-validacion-cuenta"
            style={{ textAlign: "center", paddingTop: 5 }}
          >
            {statusCuenta == ACTIVAR_CUENTA
              ? "Activación cuenta"
              : statusCuenta == REGISTRAR_USUARIO
              ? "Registro de usuario"
              : statusCuenta == VALIDACION_IDENTIDAD_INCORRECTA
              ? "Validación de identidad incorrecta"
              : statusCuenta == CUENTA_BLOQUEADA
              // ? message // bloqueo temporal y permanente
              ? "Validación Incorrecta" // bloqueo temporal y permanente
              : statusCuenta == RESTABLECER_CONTRASEÑA
              ? "Restablecimiento de contraseña"
              : statusCuenta == ERROR_SERVICIO
              ? "Tuvimos un error de conexión"
              : null}
          </h2>

          {statusCuenta == VALIDACION_IDENTIDAD_INCORRECTA ? (
            <h3
              className="componentesLogin col-xs-12 col-sm-12 col-md-12 col-lg-12 texto-subtitulo"
              style={{ fontSize: "15px", fontWeight: "bolder" }}
            >
              {`${MENSAJE_VALIDACION_IDENTIDAD_INCORRECTA}`}
            </h3>
          ) : statusCuenta == CUENTA_BLOQUEADA ? (
            <h3
              className="componentesLogin texto-subtitulo"
              style={{
                fontSize: "15px",
                fontWeight: "bolder",
                lineHeight: "24px",
                marginTop: "3em",
                marginBottom: "-2em",
                color: "#989898"
              }}
            >
              Cédula de identidad se encuentra bloqueada por el Registro Civil, regulariza tu situación. Más información en el: <a href="https://www.registrocivil.cl/" target="_blank" style={{color: "#007934"}}>Sitio Web del Registro Civil</a>
            </h3>
          ) : statusCuenta == ERROR_SERVICIO ? (
            <>
              <h3
                className="componentesLogin col-xs-12 col-sm-12 col-md-12 col-lg-12 texto-subtitulo"
                style={{ fontSize: "15px", fontWeight: "bolder", color: "black", lineHeight: "1.6em" }}
              >
                Nuestros sistemas de validación de identidad están sufriendo intermitencias
              </h3>
              <h3
                className="componentesLogin col-xs-12 col-sm-12 col-md-12 col-lg-12 texto-subtitulo"
                style={{ fontSize: "15px", fontWeight: "bolder", lineHeight: "1.6em" }}
              >
                Por favor, inténtelo nuevamente en unos minutos. Si el problema persiste, contáctanos a <span style={{color: "#1A8749", textDecoration: "underline"}}>ejecutivo@achs.cl</span>.
                Lamentamos los inconvenientes.
              </h3>
            </>
          ) : statusCuenta == ACTIVAR_CUENTA ? (
            <div>
              <p
                className="componentesLogin col-xs-12 col-sm-12 col-md-12 col-lg-12"
                style={{
                  fontSize: "16px",
                  fontWeight: "bolder",
                  color: "gray",
                  marginTop: "1em"
                }}
              >
                Link de activación enviado
              </p>
              <p
                className="componentesLogin dataInfo col-xs-12 col-sm-12 col-md-12 col-lg-12"
                style={{
                  fontSize: "14px",
                  color: "gray",
                }}
              >
                <div className="account-activation-info">
                  <p>
                    Tu link de activación ha sido enviado a tu correo electrónico y número de teléfono,
                    en caso de no recibir el link revisa tu carpeta de Spam y Correos no deseados.
                  </p>
                  <br/>
                  <p><b>Número de teléfono:</b> {phoneMasked}</p>
                  <p><b>Correo electrónico:</b> {emailMasked}</p>
                </div>
              </p>
            </div>
          ) : (
            <div>
              <p
                className="componentesLogin col-xs-12 col-sm-12 col-md-12 col-lg-12"
                style={{
                  fontSize: "14px",
                  fontWeight: "bolder",
                  color: "gray",
                }}
              >
                {message}
              </p>
              <p
                className="componentesLogin dataInfo col-xs-12 col-sm-12 col-md-12 col-lg-12"
                style={{
                  fontSize: "14px",
                  fontWeight: "bolder",
                  color: "gray",
                }}
              >
                {statusCuenta == REGISTRAR_USUARIO ? null : (
                  <ReestablecimientoMessages
                    titulo={
                      statusCuenta == RESTABLECER_CONTRASEÑA
                        ? "Tus datos de restablecimiento son los siguientes"
                        : statusCuenta == ACTIVAR_CUENTA
                        ? "Tus datos de activación son los siguientes"
                        : null
                    }
                    correo={emailMasked}
                    telefono={phoneMasked}
                  />
                )}
              </p>
            </div>
          )}

          {/* <p
            className="componentesLogin col-xs-12 col-sm-12 col-md-12 col-lg-12"
            style={{ fontSize: "14px", fontWeight: "bolder" }}
          >
            {statusCuenta == ACTIVAR_CUENTA
              ? "Haz clic en el siguiente botón para activar tu cuenta"
              : statusCuenta == REGISTRAR_USUARIO
              ? "Haz clic en el siguiente botón para registrarte"
              : statusCuenta == VALIDACION_IDENTIDAD_INCORRECTA
              ? ""
              : statusCuenta == RESTABLECER_CONTRASEÑA
              ? " Haz clic en el siguiente botón para restablecer tu contraseña"
              : null}
          </p> */}
        </div>
        {statusCuenta === ACTIVAR_CUENTA ? (
          <div
            className="componentesLogin col-xs-12 col-sm-12 col-md-12 col-lg-12"
            style={{ textAlign: "center", marginTop: "1px" }}
          >
            <div className="registro-botones justify-content-center col-xs-12 col-sm-12 col-md-12 col-lg-12 boton-achs">
                <Button
                  className="boton-achs secondary"
                  style={styles.fullWidth}
                  text="Reenviar link"
                  type="success"
                  onClick={() => {
                    dispatch(
                      EnvioEmailSMSActivacionCuenta(
                        null,
                        null,
                        envioEmailSMSActivacionCuentaNoSerie
                      )
                    );
                  }}
                />
            </div>

            <div
              className="justify-content-center col-xs-12 col-sm-12 col-md-12 col-lg-12"
            >
              <div className="contrasena justify-content-center col-xs-12 col-sm-12 col-md-12 col-lg-12">
                <a
                  onClick={() => dispatch(renderRedirectFlujoValidacionIdentidad())}
                >
                  <span>¿No tienes acceso a este número de teléfono o correo electrónico?</span>
                  <br/>
                  <span>Prueba aquí con otro método</span>
                </a>
              </div>

            </div>
          </div>
        ) : (
          <div
            className="componentesLogin col-xs-12 col-sm-12 col-md-12 col-lg-12"
            style={{ textAlign: "center", marginTop: "1px" }}
          >
            <div className="registro-botones justify-content-center col-xs-12 col-sm-12 col-md-12 col-lg-12 boton-achs">
              {statusCuenta == VALIDACION_IDENTIDAD_INCORRECTA || statusCuenta == CUENTA_BLOQUEADA || statusCuenta == ERROR_SERVICIO ? null : (
                <Button
                  className={"boton-achs"}
                  style={styles.fullWidth}
                  text={
                    statusCuenta == ACTIVAR_CUENTA
                      ? "Enviar link de activación"
                      : statusCuenta == REGISTRAR_USUARIO
                      ? "Registrar usuario"
                      : statusCuenta == RESTABLECER_CONTRASEÑA
                      ? "Restablecer contraseña"
                      : null
                  }
                  type="success"
                  // onClick={() => dispatch(renderBody(statusCuenta))}
                  onClick={() => {
                    statusCuenta == RESTABLECER_CONTRASEÑA
                      ? dispatch(
                          resolveNoSerieRestablecerConstraseñaAction(
                            {
                              Phone: phone,
                              Email: email,
                              NotificationType: 3,
                            },
                            3
                          )
                        )
                      : statusCuenta == REGISTRAR_USUARIO
                      ? dispatch(renderRedirectFlujoValidacionIdentidad())
                      : statusCuenta == ACTIVAR_CUENTA
                      ? dispatch(
                          EnvioEmailSMSActivacionCuenta(
                            null,
                            null,
                            envioEmailSMSActivacionCuentaNoSerie
                          )
                        )
                      : dispatch(renderBody(statusCuenta));
                  }}
                />
              )}
            </div>

            <div
              className={` ${
                statusCuenta == VALIDACION_IDENTIDAD_INCORRECTA ? "" : "registro"
              } justify-content-center col-xs-12 col-sm-12 col-md-12 col-lg-12`}
            >
              {statusCuenta == REGISTRAR_USUARIO ? null : (
                <Button
                  className={
                    statusCuenta == VALIDACION_IDENTIDAD_INCORRECTA || statusCuenta == CUENTA_BLOQUEADA || statusCuenta == ERROR_SERVICIO
                      ? "registro-botones-azul"
                      : "boton-achs"
                  }
                  style={styles.fullWidth}
                  text={
                    statusCuenta == RESTABLECER_CONTRASEÑA
                      ? `Otra opción de restablecimiento (validación de identidad)`
                      : statusCuenta == ACTIVAR_CUENTA
                      ? `Otra opción de activación (validación de identidad)`
                      : (statusCuenta == VALIDACION_IDENTIDAD_INCORRECTA || statusCuenta == CUENTA_BLOQUEADA || statusCuenta == ERROR_SERVICIO)
                      ? `Volver al inicio`
                      : null
                  }
                  type="success"
                  onClick={() => {
                    if (statusCuenta == VALIDACION_IDENTIDAD_INCORRECTA) {
                      dispatch(doResetState());
                      dispatch(push(paths.root));
                    } else {
                      dispatch(renderRedirectFlujoValidacionIdentidad());
                    }
                  }}
                  //onClick={() => dispatch(renderBody(statusCuenta))}
                />
              )}
            </div>
            {statusCuenta == VALIDACION_IDENTIDAD_INCORRECTA || statusCuenta == CUENTA_BLOQUEADA ? (
              <p
                className="texto-subtitulo"
                style={{ fontSize: "14px", marginTop: "10px" }}
              >
                Ante dudas, contáctanos a <a href="mailto:ejecutivoachs@achs.cl" target="_blank" style={{color: "#007934"}}>ejecutivoachs@achs.cl</a>
              </p>
            ) : null}
          </div>
        )}
      </div>
    </center>
  );
};

export default StatusCuentaUsuario;
